import { useMemo } from 'react';
import { Box, Flex } from 'theme-ui';

import { Markdown } from '@snippets';
import { parseContentPosition } from '@utils/common';
import { space } from '@theme/theme.space';

import { themed } from './CollectionHero.theme';

export const Content = themed(({ theme, text, content }) => {
  const textAlign = [content?.alignment, content?.alignmentDt];

  // Mobile content position
  const posMb = useMemo(
    () => parseContentPosition(content?.position),
    [content?.position]
  );

  // Desktop content position
  const posDt = useMemo(
    () => parseContentPosition(content?.positionDt),
    [content?.positionDt]
  );

  return (
    <Flex
      data-comp={Content.displayName}
      sx={{
        ...theme.contentWrapper,
        alignItems: [posMb.alignItems, posDt.alignItems],
        justifyContent: [posMb.justifyContent, posDt.justifyContent],
      }}
    >
      <Box
        sx={{
          ...theme.content,
          maxWidth: content?.maxWidth
            ? [
                content.maxWidth + space[12] * 2,
                content.maxWidth + space[15] * 2,
              ]
            : 'none',
        }}
      >
        <Markdown
          text={text?.heading}
          textSx={{
            ...theme.heading,
            textAlign,
          }}
          sx={{
            mb: text?.subheading ? [4, 6] : 0,
          }}
        />

        {text?.subheading && (
          <Markdown
            text={text?.subheading}
            textSx={{
              ...theme.subheading,
              textAlign,
            }}
          />
        )}
      </Box>
    </Flex>
  );
});

Content.displayName = 'Content';
